<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <!--  只有总公司账号才有权限选择开票公司 -->
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item v-if="this.icId == 0" label="开票单位" prop="invoice_company_id">
          <el-select v-model="table.params.invoice_company_id" placeholder="请选择" clearable filterable @change="onSearch">
            <el-option
              v-for="item in invoiceCompanyOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btnAdd">
        <el-button :size="subUnitSize" type="primary" icon="el-icon-plus" @click="showEdit">创建</el-button>
      </div>
    </div>
    
    <VTable
      has-pagionation
      title=''
      addText='添加'
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page='table.params.page'
      :pageSize='table.params.count'
      :total='table.total'
      :tree-props="{children: 'children', hasChildren: 'has_child'}"
      :hasPagionation="true"
      :default-expand-all="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:illness_base="{row}">
        <span>{{row.invoice_company_id == 2 ? '--' : row.illness_base}}</span>
      </template>
      <template v-slot:action="{row}">
        <el-button type="text" @click='showEdit(row)'>查看</el-button>
        <el-button type="text" @click='remove(row)'>删除</el-button>
      </template>
    </VTable>

    <edit ref="edit" :invoiceCompanyOpt="this.invoiceCompanyOpt" @refresh="getTable"></edit>
    
  </div>
</template>

<script>
import Edit from './components/Edit.vue'
import VTable from '@/components/VTable';
import {getStorage} from '@/storage'
import { mapGetters } from 'vuex'
import { mixinTable } from '@/mixins/table.js'
export default {
  name: '',
  mixins:[mixinTable],
  components: {
    Edit,
    VTable
  },
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "id", label: "ID", width:'80' },
        { name: "invoice_company_name", label: "开票单位", width:"210",  hidden: false },
        { name: "name", label: "基数档次", width:"180", hidden: false },
        { name: "endowment_base", label: "养老保险基数", hidden: false },
        { name: "medical_base", label: "医疗保险基数", hidden: false},
        { name: "birth_base", label: "生育保险基数", hidden: false},
        { name: "injury_base", label: "工伤保险基数", hidden: false},
        { name: "unemployment_base", label: "失业保险基数", hidden: false},
        { name: "extra_injury_base", label: "补充工伤险基数", hidden: false},
        { name: "illness_base", label: "大病医疗险基数", hidden: false},
        { name: "company_total", label: "单位部分", hidden: false},
        { name: "employees_total", label: "员工部分", hidden: false},
        { name: "total", label: "总计", hidden: false},
        { name: "created_at", label: "创建时间", width: "160", hidden: false},
        { name: "action", label: "操作",width: "120", hidden: false }
      ],
      table: {
        loading: false,
        params: {
          invoice_company_id: '',
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
      },
      rowId: '',
      isDetail: false,
      icId: Number(getStorage('icId')), // 登录账号的身份id（0：总公司, 2:鹰潭分公司）
    }
  },
  computed: {
    ...mapGetters({
      invoiceCompanyOpt: 'invoiceCompany', // 获取开票单位列表
    })
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http.post('/admin/InsuranceLevel/list', this.table.params).then(res => {
        if(res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showEdit(row) {
      let dom = this.$refs.edit
      dom.toggle(true)
      if (!!row.id) {
        dom.getDetail(row)
      }
      dom = null
    },
    // 删除
    remove(row) {
      this.$confirm("是否删除此条记录？", "删除", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.delete(row.id);
            done()
          } else {
            done()
          }
        }
      }).catch(() => {})
    },
    delete(rowid) {
      this.$http.post('/admin/InsuranceLevel/delete', { id: rowid }).then(res => {
        if(res.code === 1) {
          this.$message.success('操作成功！')
          this.getTable();
        } else {
          this.$message.error(res.data)
        }
      })
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    },
  }
}
</script>